import { MultiSelect } from 'primereact/multiselect';

import { cn } from '@shared/lib/cn';

import type { SelectOption } from './BaseSelect';

export interface BaseMultiSelectProps<T extends string> {
  id: string;
  value: T[];
  options: readonly SelectOption<T>[];
  onChange: (value: T[]) => void;
  onBlur?: () => void;
  placeholder?: string;
  disabled?: boolean;
  invalid?: boolean;
  /** Type-to-filter inside the list (long lists such as states). */
  searchable?: boolean;
  className?: string;
  'aria-label'?: string;
}

/** Pick one or more values; the chosen ones show as chips. */
export function BaseMultiSelect<T extends string>({
  id,
  value,
  options,
  onChange,
  onBlur,
  placeholder,
  disabled,
  invalid,
  searchable,
  className,
  'aria-label': ariaLabel,
}: BaseMultiSelectProps<T>) {
  return (
    <MultiSelect
      inputId={id}
      value={value}
      options={[...options]}
      optionLabel="label"
      optionValue="value"
      optionDisabled="disabled"
      onChange={(e: { value: T[] | null }) => {
        onChange(e.value ?? []);
      }}
      onBlur={onBlur}
      placeholder={placeholder}
      disabled={disabled}
      invalid={invalid}
      filter={searchable}
      resetFilterOnHide
      display="chip"
      removeIcon="pi pi-times"
      showSelectAll={false}
      aria-label={ariaLabel}
      className={cn('w-full', className)}
    />
  );
}
